// Consistent status badge used across Orders, Jobs, Users and Monitoring.

const STYLES: Record<string, string> = {
  // Order + job lifecycle
  pending: 'bg-amber-50 text-amber-700 ring-amber-600/20',
  confirmed: 'bg-sky-50 text-sky-700 ring-sky-600/20',
  available: 'bg-sky-50 text-sky-700 ring-sky-600/20',
  assigned: 'bg-indigo-50 text-indigo-700 ring-indigo-600/20',
  driverAssigned: 'bg-indigo-50 text-indigo-700 ring-indigo-600/20',
  accepted: 'bg-indigo-50 text-indigo-700 ring-indigo-600/20',
  enRoute: 'bg-blue-50 text-blue-700 ring-blue-600/20',
  pickedUp: 'bg-violet-50 text-violet-700 ring-violet-600/20',
  inTransit: 'bg-purple-50 text-purple-700 ring-purple-600/20',
  delivered: 'bg-green-50 text-green-700 ring-green-600/20',
  completed: 'bg-green-50 text-green-700 ring-green-600/20',
  cancelled: 'bg-red-50 text-red-700 ring-red-600/20',
  disputed: 'bg-orange-50 text-orange-700 ring-orange-600/20',
  // User / verification
  approved: 'bg-green-50 text-green-700 ring-green-600/20',
  rejected: 'bg-red-50 text-red-700 ring-red-600/20',
  pending_review: 'bg-amber-50 text-amber-700 ring-amber-600/20',
  suspended: 'bg-red-50 text-red-700 ring-red-600/20',
  active: 'bg-green-50 text-green-700 ring-green-600/20',
  online: 'bg-green-50 text-green-700 ring-green-600/20',
  offline: 'bg-slate-100 text-slate-600 ring-slate-500/20',
  missing: 'bg-slate-100 text-slate-600 ring-slate-500/20',
  error: 'bg-red-50 text-red-700 ring-red-600/20',
  ok: 'bg-green-50 text-green-700 ring-green-600/20',
};

/** Turn camelCase / snake_case status keys into readable labels. */
function label(status: string): string {
  return status
    .replace(/_/g, ' ')
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .toLowerCase();
}

export default function StatusBadge({ status }: { status?: string | null }) {
  if (!status) return <span className="text-slate-400">—</span>;
  const cls = STYLES[status] ?? 'bg-slate-100 text-slate-600 ring-slate-500/20';
  return (
    <span
      className={`inline-flex items-center whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset ${cls}`}
    >
      {label(status)}
    </span>
  );
}
